/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OneSignal
 */
export interface OneSignal {
    /**
     * 
     * @type {string}
     * @memberof OneSignal
     */
    userAuthKey?: string;
    /**
     * 
     * @type {string}
     * @memberof OneSignal
     */
    restApiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof OneSignal
     */
    appName?: string;
    /**
     * 
     * @type {string}
     * @memberof OneSignal
     */
    gcmKey?: string;
    /**
     * 
     * @type {string}
     * @memberof OneSignal
     */
    gcmSenderId?: string;
    /**
     * 
     * @type {number}
     * @memberof OneSignal
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof OneSignal
     */
    courierId?: number;

    appId?: string;
    safariWebId?: string;
    notifyButtonEnabled?: boolean;
    // Optional dev overrides to support local testing with different OneSignal app configured for localhost
    appIdDev?: string;
    safariWebIdDev?: string;
}

/**
 * Check if a given object implements the OneSignal interface.
 */
export function instanceOfOneSignal(value: object): value is OneSignal {
    return true;
}

export function OneSignalFromJSON(json: any): OneSignal {
    return OneSignalFromJSONTyped(json, false);
}

export function OneSignalFromJSONTyped(json: any, ignoreDiscriminator: boolean): OneSignal {
    if (json == null) {
        return json;
    }
    return {
        
        'userAuthKey': json['userAuthKey'] == null ? undefined : json['userAuthKey'],
        'restApiKey': json['restApiKey'] == null ? undefined : json['restApiKey'],
        'appName': json['appName'] == null ? undefined : json['appName'],
        'gcmKey': json['gcmKey'] == null ? undefined : json['gcmKey'],
        'gcmSenderId': json['gcmSenderId'] == null ? undefined : json['gcmSenderId'],
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'appId': json['appId'] == null ? undefined : json['appId'],
        'safariWebId': json['safariWebId'] == null ? undefined : json['safariWebId'],
        'notifyButtonEnabled': json['notifyButtonEnabled'] == null ? undefined : json['notifyButtonEnabled'],
        'appIdDev': json['appIdDev'] == null ? undefined : json['appIdDev'],
        'safariWebIdDev': json['safariWebIdDev'] == null ? undefined : json['safariWebIdDev'],
    };
}

export function OneSignalToJSON(json: any): OneSignal {
    return OneSignalToJSONTyped(json, false);
}

export function OneSignalToJSONTyped(value?: OneSignal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userAuthKey': value['userAuthKey'],
        'restApiKey': value['restApiKey'],
        'appName': value['appName'],
        'gcmKey': value['gcmKey'],
        'gcmSenderId': value['gcmSenderId'],
        'id': value['id'],
        'courierId': value['courierId'],
        'appId': value['appId'],
        'safariWebId': value['safariWebId'],
        'notifyButtonEnabled': value['notifyButtonEnabled'],
        'appIdDev': value['appIdDev'],
        'safariWebIdDev': value['safariWebIdDev'],
    };
}

